<script setup lang="ts">
/* eslint-disable max-len */
export interface IconFilterProps {
  fill?: string;
  width?: number;
  height?: number;
}
const props = withDefaults(defineProps<IconFilterProps>(), { fill: "#A9B7D1", width: 20, height: 20 });
</script>

<template>
  <svg :width="props.width" :height="props.height" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.585.728A1.384 1.384 0 0 0 17.355 0H1.407C.9 0 .418.27.178.728c-.241.458-.241.997.026 1.428.027.027.027.054.054.081l6.394 8.49v6.12c0 .377.187.727.508.916l3.291 2.075c.16.108.375.162.562.162a1.1 1.1 0 0 0 .509-.135c.347-.189.562-.539.562-.943v-8.194l6.394-8.49c.027-.027.027-.054.053-.081.268-.432.295-.97.054-1.429z" :fill="props.fill" fill-rule="evenodd" />
  </svg>
</template>
